/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Overview_TitleInputs */

const es_billing_overview_title = /** @type {(inputs: Billing_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen del período`)
};

const en_billing_overview_title = /** @type {(inputs: Billing_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing overview`)
};

/**
* | output |
* | --- |
* | "Billing overview" |
*
* @param {Billing_Overview_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_overview_title = /** @type {((inputs?: Billing_Overview_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Overview_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_overview_title(inputs)
	return en_billing_overview_title(inputs)
});
export { billing_overview_title as "billing.overview.title" }